<template>
  <div class="app">
    <div class="title">
      <div class="dis">
        <div class="title_text">客户管理</div>
      </div>
    </div>

    <div class="head_box">
      <div class="ipt_list">
        <div class="box1">
          <div class="dis">
            <div class="first_title">客户ID</div>
            <el-input v-model="value1" placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <div class="box1">
          <div class="dis">
            <div class="other_title">客户名称</div>
            <el-input v-model="value2" placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <div class="box1">
          <div class="dis">
            <div class="other_title">信用代码</div>
            <el-input v-model="value3" placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <div class="box1">
          <div class="dis">
            <div class="other_title">联系人</div>
            <el-input v-model="value4" placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <div class="box1">
          <div class="dis">
            <el-button class="search_btn dis_center" type="primary" @click="rold()">
              <div class="dis_center">
                <div>搜索</div>
              </div>
            </el-button>

            <el-button class="Add_btn dis_center" type="primary" @click="add_btn(0)">
              <div class="dis_center">
                <img class="img11" src="../../assets/12.png" alt="" />
                <div>新增</div>
              </div>
            </el-button>
          </div>

        </div>
      </div>
    </div>
    <div class="table_pad">
      <div class="table">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe
          @selection-change="handleSelectionChange" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ textAlign: 'center' }">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column type="index" label="序号" width="65">
          </el-table-column>
          <!-- <el-table-column prop="levelId" label="头像" min-width="8%">
            <template slot-scope="scope">
              <div>
                <img :src="img_url + scope.row.avatar" class="img_level" alt="" srcset="" />
              </div>
            </template>
</el-table-column> -->
          <el-table-column prop="id" label="客户ID" min-width="8%">
          </el-table-column>
          <el-table-column prop="customerName" label="客户名称" min-width="10%">
          </el-table-column>
          <el-table-column prop="creditCode" label="信用代码" min-width="10%">
          </el-table-column>
          <el-table-column prop="address" label="地址" min-width="10%">
          </el-table-column>
          <el-table-column prop="contactPerson" label="联系人" min-width="10%">
          </el-table-column>
          <el-table-column prop="contactPhone" label="联系电话" min-width="10%">
          </el-table-column>
          <el-table-column prop="remarks" label="备注" min-width="10%">
          </el-table-column>
          <el-table-column prop="address" label="操作" min-width="12%">
            <template slot-scope="scope">
              <div class="dis_center table_btn">
                <div class="dis" @click="jump(scope.row)">
                  <div>查看项目</div>
                </div>
                <div class="dis" @click="add_btn(1, scope.row)">
                  <div>修改</div>
                </div>
                <div class="dis table_delete" @click="delete_btn(0, scope.row.id)">
                  <div>删除</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page_box">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page.sync="pageNumber" :total="total">
        </el-pagination>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_shardow">
      <div class="show_box">
        <div class="show_title dis_center">
          <div v-if="show_type == 0">新增客户</div>
          <div v-else>修改客户</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="show_detail" style="height: 400rem;">
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>客户名称：</div>
            <el-input class="shardow_ipt" v-model="info.customerName" placeholder="请输入"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>信用代码：</div>
            <el-input class="shardow_ipt" v-model="info.creditCode" placeholder="请输入"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>地 址：</div>
            <el-input class="shardow_ipt" v-model="info.address" placeholder="请输入"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>联系人：</div>
            <el-input class="shardow_ipt" v-model="info.contactPerson" placeholder="请输入"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>联系电话：</div>
            <el-input class="shardow_ipt" v-model="info.contactPhone" placeholder="请输入"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">备 注：</div>
            <el-input class="shardow_ipt" v-model="info.remarks" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <button class="shardow_btn2 dis_center" @click="save" :disabled="disabled_save">
            确定
          </button>
        </div>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_delete">
      <div class="show_box">
        <div class="show_title dis_between">
          <div>删除确认</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="dis_center shardow_deleteInfo">
          <img src="../../assets/20.png" class="img20" alt="" />
          <div>确定要删除所选择的客户吗？</div>
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <div class="shardow_btn2 dis_center" @click="remove">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  api,
  img_url,
  getCustomerMePage,
  editCustomer,
  removeCustomer,
} from "../js/api";
import axios from "axios";
export default {
  data() {
    return {
      img_url: "",
      max_level: 1,
      disabled_save: false,
      userInfo: {},
      info: {
        customerName: '', // 客户名称
        creditCode: '', // 信用代码
        address: '', // 地址
        contactPerson: '', // 联系人
        contactPhone: '', // 联系电话
        remarks: '' // 备注
      },
      multipleSelection: [],
      chooseId: "",
      show_type: 0,
      show_shardow: false,
      show_delete: false,
      delete_type: 0,
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      input: "",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      tableData: [],
      userList: [], // 用户列表
      options1: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      multipleSelection: [],
    };
  },
  created() {
    let that = this;
    that.img_url = img_url;
    that.userInfo = JSON.parse(localStorage.getItem("userInfo"));

    that.ajaxload();
    // that.getUserList();
  },
  methods: {

    jump(e) {
      let that = this;
      that.$router.push('./projectManagement?customerId=' + e.id)
    },
    selectImg(e) {
      this.choose_type = e;
      document.getElementById("filed_page").click();
    },
    filePreview(e) {
      let that = this; //上传前页面显示图片
      console.log(that.choose_type);
      that.url = URL.createObjectURL(e.target.files[0]);
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      // formData.append("compNo", localStorage.getItem("compNo")); // 通过append向form对象添加数据,上传文件的同时， 也可以上传其他数据
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      }; //添加请求头
      // return;

      axios.post(api + "/file/upload/1", formData, config).then((response) => {
        //这里的/xapi/upimage为接口
        if (response.data.code == 200) {
          // let path = api + "/" + response.data.data;
          let path = response.data.data;
          let info = that.info;
          console.log(info, path);
          info.avatar = path;
          that.info = info;
        } else {
          that.$message.error(response.data.message);
        }
      });
    },
    select_change(e) {
      let that = this;
      let options1 = that.options1;
      for (let i in options1) {
        if (options1[i].id == e) {
          that.info.companyName = options1[i].companyName;
        }
      }
      console.log(e);
    },
    // 获取用户列表
    getUserList() {
      let that = this;
      let json = {};
      getUserListNoPage({ params: json }).then((res) => {
        console.log('用户列表:', res);
        if (res.code == 200) {
          let data = res.data;
          that.userList = data;
        } else {
          that.$message.error(res.message || '获取用户列表失败');
        }
      }).catch(err => {
        console.error('获取用户列表失败:', err);
        that.$message.error('获取用户列表失败');
      });
    },

    rold() {
      let that = this;
      that.pageNumber = 1;
      that.ajaxload();
    },
    ajaxload() {
      let that = this;
      let json = {
        entityParam: {

        },
        pageReq: {
          pageNumber: that.pageNumber,
          pageSize: that.pageSize,
        }
      };

      if (that.value1) {
        json.entityParam.id = that.value1;
      }
      if (that.value2 || that.value3 || that.value4) {
        json.keyWords = {}
      }
      if (that.value2) {
        json.keyWords.customerName = that.value2
      }
      if (that.value3) {
        json.keyWords.creditCode = that.value3
      }
      if (that.value4) {
        json.keyWords.contactPerson = that.value4
      }



      getCustomerMePage(json).then((res) => {
        console.log('客户列表:', res);
        if (res.code == 200) {
          let data = res.data.records;
          that.tableData = data;
          that.total = Number(res.data.total);
        } else {
          this.$message.error(res.message || '获取客户列表失败');
        }
      }).catch(err => {
        console.error('获取客户列表失败:', err);
        this.$message.error('获取客户列表失败');
      });
    },
    save() {
      let that = this;
      that.disabled_save = true;
      let json = that.info;

      // 验证必填字段
      if (!json.customerName) {
        this.$message({
          message: "请输入客户名称",
          type: "warning",
          duration: 1000,
        });
        that.disabled_save = false;
        return;
      }
      if (!json.creditCode) {
        this.$message({
          message: "请输入信用代码",
          type: "warning",
          duration: 1000,
        });
        that.disabled_save = false;
        return;
      }
      if (!json.address) {
        this.$message({
          message: "请输入地址",
          type: "warning",
          duration: 1000,
        });
        that.disabled_save = false;
        return;
      }
      if (!json.contactPerson) {
        this.$message({
          message: "请输入联系人",
          type: "warning",
          duration: 1000,
        });
        that.disabled_save = false;
        return;
      }
      if (!json.contactPhone) {
        this.$message({
          message: "请输入联系电话",
          type: "warning",
          duration: 1000,
        });
        that.disabled_save = false;
        return;
      }

      console.log(json)
      editCustomer(json).then((res) => {
        that.disabled_save = false;
        console.log('保存结果:', res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "保存成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message || '保存失败');
        }
      }).catch(err => {
        that.disabled_save = false;
        console.error('保存失败:', err);
        this.$message.error('保存失败，请重试');
      });
    },
    remove() {
      let that = this;
      let json = {};
      json.id = that.chooseId;
      removeCustomer(json.id).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "删除成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
          that.close();
          that.ajaxload();
        }
      });
    },
    delete_btn(e, w) {
      let that = this;
      if (e == 0) {
        that.chooseId = w;
      } else if (e == 1) {
        if (that.multipleSelection.length == 0) {
          this.$message({
            message: "请选择用户",
            type: "warning",
          });
          return;
        }
      }
      that.delete_type = e;
      that.show_delete = true;
    },
    add_btn(e, w) {
      let that = this;
      if (e == 0) {
        // 新增学生
        that.info = {
          avatar: '', // 头像
          classId: '', // 班级ID
          className: '', // 班级名称
          curentFlag: 1, // 当前标志
          gradeId: '', // 年级ID
          gradeName: '', // 年级名称
          schoolId: '', // 学校ID
          name: '', // 学校名称
          studentName: '', // 学生姓名
          userId: '', // 用户ID
          areaId: '', // 地区ID
          areaName: '' // 地区名称
        };
        // 清空级联选择器
        // that.schoolList = [];
        that.gradeList = [];
        that.classList = [];
      } else {
        // 修改学生
        that.info = JSON.parse(JSON.stringify(w));
        // 如果有地区ID，加载对应的学校列表
        if (that.info.areaId) {
          that.getSchoolListByArea(that.info.areaId);
        }
        // 如果有学校ID，加载对应的年级列表
        if (that.info.schoolId) {
          setTimeout(() => {
            that.getGradeListBySchool(that.info.schoolId);
          }, 500);
        }
        // 如果有年级ID，加载对应的班级列表
        if (that.info.gradeId) {
          setTimeout(() => {
            that.getClassListByGrade(that.info.gradeId);
          }, 1000);
        }
      }
      that.show_type = e;
      that.show_shardow = true;
    },
    close() {
      let that = this;
      that.show_shardow = false;
      that.show_delete = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      let that = this;
      that.pageNumber = val;
      that.ajaxload();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../userManagement/userManagement.css");


.show_detail {
  height: 444rem;
}

.shardow_title {
  width: 120rem;
}


.img62 {
  width: 18rem;
  height: 14rem;
}

.img_banner {
  width: 40rem;
  height: 30rem;
}

.img_level {
  width: 40rem;
  height: 40rem;
  border-radius: 50%;
}

>>>.el-button {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/MembershipSettings/MembershipSettings.vue